import Resource from '@/plugins/sdk/Resource'
import { UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'portfolio_type'

  static get fields () {
    return {
      id: new UUID()
    }
  }
}
